import { Component, OnInit, HostListener } from '@angular/core';
import { AuthenticationService, SurveyService, AlertService } from '../_services/index';
import {Router,ActivatedRoute} from "@angular/router"
import { environment } from '../../environments/environment';
import * as Prism from 'prismjs';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {
    public loading =false;
    copyright = {
        version: environment.APP_VERSION,
        year: environment.YEAR,
        name: environment.NAME
    }
    public responseY = {
        yes:true,
        not:false
    }
    public survey:any;
    private authorized:any;
    public postSurvey:any={
        token:'',
        userCode:'',
        entries:[]
    };
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public surveyService:SurveyService,
        public alertService:AlertService,
        public as: AuthenticationService,
    ){
        this.authorized = this.as.checkAuthentication();
        if(this.authorized.authorized){
            this.router.navigate(['/inicio']);
        }
    }
    ngOnInit() {
        if (this.route.snapshot.params && this.route.snapshot.params.form && this.route.snapshot.params.user) {
            this.getSurvey(this.route.snapshot.params.form,this.route.snapshot.params.user)
        }else{
            this.alert({reason:'No se ha podido cargar la encuesta.', type:"danger"});
            this.router.navigate(['/']);
        }
    }
    getSurvey(form,user){
        this.surveyService.getSurveyEmployee(form,user).subscribe(response => {
            this.survey = response;
            if(this.survey && this.survey.token && this.survey.user.code){
                this.postSurvey.token = this.survey.token;
                this.postSurvey.userCode =  this.survey.user.code;
            }
            if(!this.survey || this.survey && this.survey.message){
                this.alert({reason:'No se ha podido cargar la encuesta.', type:"danger"});
                this.router.navigate(['/']);
            }
        }, error => {
            this.alert({reason:'No se ha podido cargar la encuesta.', type:"danger"});
            this.router.navigate(['/']);
        })
    }
    updateSurvey(){
        
        this.loading = true;
        this.postSurvey.entries = []
        this.survey.questions.forEach(question => {
            this.postSurvey.entries.push({questionId:question.id,value:question.value?question.value:false})
        });
        this.surveyService.updateSurvey(this.postSurvey).subscribe(response => {
            this.survey = response;
            this.loading = false;
            this.alert({reason:'La encuesta ha sido enviada con éxito.', type:"success"});
            this.router.navigate(['/']);
        }, error => {
            this.loading = false;
            this.alert({reason:'La encuesta no ha sido enviada, intentalo nuevamente.', type:"danger"});
            this.router.navigate(['/']);
        })
    }
    changePage(page){
        this.router.navigate(['/'+page])
    }
    alert(data){
        this.alertService.updateAlert(data).subscribe(()=>{
            setTimeout(() => {
            this.alertService.deleteAlert().subscribe();
            }, 8000);
        })
    }
}
